import "normalize.css/normalize.css";
import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

import "./App.css";

import { HomeRedirect } from "./components/HomeRedirect";
import { Layout } from "./components/Layout";
import { OrbitUploadPanel } from "./components/OrbitUploadPanel";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CatalogObjectInformation } from "./components/catalog/CatalogObjectInformation";
import { ConjunctionInformation } from "./components/conjunctions/ConjunctionInformation";
import { OrbitInformation } from "./components/orbits/OrbitInformation";
import { MODULES } from "./components/sideBarItems";
import { AdditionalServicesContainer } from "./containers/AdditionalServicesContainer";
import { CatalogContainer } from "./containers/CatalogContainer";
import { ConjunctionsContainer } from "./containers/ConjunctionsContainer";
import { EventEvolutionContainer } from "./containers/EventEvolutionContainer";
import { FleetContainer } from "./containers/FleetContainer";
import { Forbidden } from "./containers/Forbidden";
import { PhonebookContainer } from "./containers/PhonebookContainer";
import { SettingsContainer } from "./containers/SettingsContainer";
import { UserAccessContainer } from "./containers/UserAccessContainer";
import { ROLES } from "./hooks/useRoles";

const App: React.FC = () => {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route
            element={
              <ProtectedRoute required={[MODULES.CONJUNCTIONS, ROLES.ADMIN]} />
            }
          >
            <Route path="/fleet" element={<FleetContainer />} />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.CONJUNCTIONS, ROLES.ADMIN]} />
            }
          >
            <Route
              path="/fleet/:id/info"
              element={<ConjunctionInformation pageTitle={"Fleet status"} />}
            />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.CONJUNCTIONS, ROLES.ADMIN]} />
            }
          >
            <Route
              path="/conjunctions/:page?"
              element={<ConjunctionsContainer />}
            />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.CONJUNCTIONS, ROLES.ADMIN]} />
            }
          >
            <Route
              path="/conjunctions/:id/info"
              element={<ConjunctionInformation />}
            />
          </Route>

          <Route path="/catalogue" element={<CatalogContainer />} />
          <Route
            path="/catalogue/:id/info"
            element={<CatalogObjectInformation />}
          />

          <Route
            path="/event/:uuid/info"
            element={<EventEvolutionContainer />}
          />

          <Route
            element={
              <ProtectedRoute
                required={[
                  MODULES.ORBITS,
                  MODULES.UPLOAD,
                  ROLES.ADMIN,
                  ROLES.UPLOAD,
                ]}
              />
            }
          >
            <Route path="/orbits/:page?" element={<OrbitUploadPanel />} />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.ORBITS, ROLES.ADMIN]} />
            }
          >
            <Route path="/orbits/:id/info" element={<OrbitInformation />} />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.PHONEBOOK, ROLES.ADMIN]} />
            }
          >
            <Route path="/phonebook" element={<PhonebookContainer />} />
          </Route>

          <Route
            element={
              <ProtectedRoute
                required={[MODULES.USER_MANAGEMENT, ROLES.ADMIN]}
              />
            }
          >
            <Route path="/user-management" element={<UserAccessContainer />} />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[MODULES.SETTINGS, ROLES.ADMIN]} />
            }
          >
            <Route path="/settings" element={<SettingsContainer />} />
          </Route>

          <Route
            element={
              <ProtectedRoute required={[ROLES.ADMIN]} />
            }
          >
            <Route
              path="/additional-services"
              element={<AdditionalServicesContainer />}
            />
          </Route>

          <Route path="/" element={<HomeRedirect />} />

          <Route path="/403" element={<Forbidden />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
};
export default App;
